import { render, staticRenderFns } from "./mecData.vue?vue&type=template&id=10673712&scoped=true&"
import script from "./mecData.vue?vue&type=script&lang=js&"
export * from "./mecData.vue?vue&type=script&lang=js&"
import style0 from "./mecData.vue?vue&type=style&index=0&id=10673712&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10673712",
  null
  
)

export default component.exports